import { ref, storage, deleteObject } from '../firebase/storageConfig';

export const deleteFile = async (url: string) => {
  const desertRef = ref(storage, url);
  await deleteObject(desertRef);
};
